import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { DescriptionStreamAnalyticsComponent } from '../stream-details/deliverables/description-stream-analytics/description-stream-analytics.component';
import { StreamDetailsComponent } from '../stream-details/stream-details.component';

@Component({
  imports: [StreamDetailsComponent, DescriptionStreamAnalyticsComponent],
  selector: 'app-youtube-stream-details',
  templateUrl: './youtube-stream-details.component.html',
})
export class YoutubeStreamDetailsComponent extends DeliverableAnalyticsContentDirective {}
